import { render, staticRenderFns } from "./IpsToast.vue?vue&type=template&id=5da6b63c"
import script from "./IpsToast.vue?vue&type=script&lang=js"
export * from "./IpsToast.vue?vue&type=script&lang=js"
import style0 from "./IpsToast.vue?vue&type=style&index=0&id=5da6b63c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports